import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Group from '../../models/Group';
import Home from '../../models/Home';
import User from '../../models/User';
import Dimensions from '../../utils/Dimensions';

export class UserContext extends React.Component {
    static propTypes = {
        user: PropTypes.instanceOf(User),
        homes: PropTypes.arrayOf(PropTypes.instanceOf(Home)),
        friends: PropTypes.arrayOf(PropTypes.instanceOf(User)),
        groups: PropTypes.arrayOf(PropTypes.instanceOf(Group)),
        children: PropTypes.element.isRequired
    };

    static childContextTypes = {
        user: PropTypes.instanceOf(User),
        homes: PropTypes.arrayOf(PropTypes.instanceOf(Home)),
        friends: PropTypes.arrayOf(PropTypes.instanceOf(User)),
        groups: PropTypes.arrayOf(PropTypes.instanceOf(Group))
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    getChildContext() {
        return {
            user: this.props.user,
            homes: this.props.homes,
            friends: this.props.friends,
            groups: this.props.groups
        };
    }

    componentDidMount() {
        // resize fake container
        const container = $('.fake-container');
        container.css({
            height:
                $(window).height() -
                (Dimensions.getNavHeight() +
                    parseInt(container.css('margin-top'), 10) +
                    parseInt(container.css('margin-bottom'), 10))
        });
    }

    render() {
        if (this.props.user) {
            return React.Children.only(this.props.children);
        } else {
            return <div className="fake-container" />;
        }
    }
}

const mapStateToProps = function (state) {
    const { user, homes } = state;
    if (user && homes) {
        user.set('homes', homes);
    }
    return {
        user,
        homes,
        friends: state.friends.users,
        groups: state.user && state.user.id ? state.userGroups[state.user.id] : null
    };
};

export default connect(mapStateToProps)(UserContext);
